import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";

export class ChiefComplaint extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      chiefComplaint: "",
      historyofPresentIllness: "",
      patientName: localStorage.getItem("currentVisitName"),
      loading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    var self = this;
    $(".randomBloodSugar").focusout(function () {
      $(".bloodSugarSelect").show();
    });
    $(".selectUnit").click(function () {
      $(".randomBloodSugar").show();
      var currentBloodSugar = self.state.randomBloodSugar;

      var unit = $(this).text();

      self.setState({
        randomBloodSugar: currentBloodSugar + "" + unit,
      });
      console.log(self.state.randomBloodSugar);
    });

    $(".data-entered").click(function () {
      $(".HistoryModal").show();
    });

    $(".height").focusout(function () {
      var weight = parseInt($(".weight").attr("value"));

      var height = parseInt($(".height").attr("value")) / 100;

      var BMI = weight / (height * height);

      var finalBMI = BMI.toString();

      self.setState({
        BMI: finalBMI,
      });

      // alert(self.state.BMI)
      // $(this).attr('value', thisValue+' ')
    });

    $(".proceed").on("click", function () {
      window.location.href = "/medical/home";
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    console.log(localStorage.getItem("accessToken"));
    this.setState({
      loading:true
    })
    axios
      .post(
        this.api_url+""+localStorage.getItem('currentModule')+"/chiefcomplaint/main",
        this.state,
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log(response);
        this.setState({
          loading:false
        })
        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            //
            $(".checkHistory").click();
          }, 1500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "20px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const { chiefComplaint, historyofPresentIllness, patientName, loading } = this.state;
    return (
      <div>
        <Headers />
        <TriageSidebar />

        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-12 font-weight-bold p-1">
                <p className="text-capitalize" style={font16}>
                  Chief Complaint and History of PresentIllness
                </p>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      {" "}
                      Chief Complaint
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={chiefComplaint}
                      name="chiefComplaint"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      {" "}
                      History of Present Illness
                    </h6>
                    <textarea
                      className="form-control"
                      onChange={this.handleChange}
                      value={historyofPresentIllness}
                      name="historyofPresentIllness"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
          
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                {/* <a className="btn btn-primary checkHistory" style={displayHidden}>Check Patient History</a> */}
                {/* <div  className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold data-entered" type="button" style={floatRight}>See the Data Entered</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading ? 'Loading' : 'Submit'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default ChiefComplaint;
